import translations from '../../lang/da/pendlertjek.json';

// Loaded before main.js; keep the globals expected by the existing Vue app.
const config = window.PENDLERTJEK_CONFIG || {};
window.BASE_URL = window.location.origin;
window.API_POINT = config.API_POINT || '';
window.PENDLER_API_KEY = config.PENDLER_API_KEY || '';
window.TRANSLATIONS = translations;
window.LOCALE = 'da';
window.VERSION = config.VERSION || '1';
if (config.BASIC_AUTH) {
    window.BASIC_AUTH = config.BASIC_AUTH;
}

window.INPUT_DATA = {};
const params = new URLSearchParams(window.location.search);
['from', 'to', 't', 'd', 'dw', 'calc'].forEach((key) => {
    // PHP keeps the last value for repeated scalar query parameters.
    const values = params.getAll(key);
    if (values.length) {
        window.INPUT_DATA[key] = values[values.length - 1];
    }
});

if (window.location.search.length > 1) {
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex, nofollow';
    document.head.appendChild(robots);
}
document.querySelector('meta[property="og:url"]').content =
    window.location.origin + window.location.pathname;
